import React from "react";
import { withRouter } from 'react-router-dom';
import { getQueryStringParams } from "sharedUtils/navUtils";
import RakutenMerchantData from './RakutenMerchantData';
import AvantLinkMerchantData from './AvantLinkMerchantData';
import ImpactMerchantData from './ImpactMerchantData';
import CJAffiliateMerchantData from './CJAffiliateMerchantData';
import PartnerizeMerchantData from './PartnerizeMerchantData';
import AwinMerchantData from './AwinMerchantData';
import AscendMerchantData from "./AscendMerchantData";
import ShareASaleMerchantData from "./ShareASaleMerchantData";
import SovrnMerchantData from "./SovrnMerchantData";
import FlexoffersMerchantData from "./FlexoffersMerchantData";
import DigiDipMerchantData from "./DigiDipMerchantData";

class AffiliateMerchantData extends React.Component {

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
    }

    renderAffiliateComponent = () => {
        const { affiliateProgramManager } = this.props;

        switch (affiliateProgramManager.name) {
            case "CJAffiliate":
                return <CJAffiliateMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />                
            case "Rakuten":
                return <RakutenMerchantData affiliateProgramManager={this.props.affiliateProgramManager}  loggedInUser={this.props.loggedInUser} />
            case "Ascend":
                return <AscendMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />                
            case "Awin":
                return <AwinMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />                
            case "AvantLink":
                return <AvantLinkMerchantData affiliateProgramManager={this.props.affiliateProgramManager}  loggedInUser={this.props.loggedInUser} />
            case "Impact":
                return <ImpactMerchantData affiliateProgramManager={this.props.affiliateProgramManager}  loggedInUser={this.props.loggedInUser} />                
            case "Partnerize":
                return <PartnerizeMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />                
            case "ShareASale":
                return <ShareASaleMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />  
            case "Sovrn":
                return <SovrnMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} />   
            case "Flexoffers":
                return <FlexoffersMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} /> 
            case "DigiDip":
                return <DigiDipMerchantData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Amazon":
                return <h1 style={{ background: "white", textAlign: "center", }}>Amazon has no merchant data</h1>;
            default:
                return <h1>Unknown Affiliate Program</h1>;
        }
    }

    render() {
        return (
            <>
                {this.renderAffiliateComponent()}
            </>
        )
    }
}

export default withRouter(AffiliateMerchantData);
